import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/e3_safety_lock.svg'

const SafetyLockIcon: React.FC<SvgIconProps> = props => <SvgIcon viewBox="0 0 60 60" component={Icon} {...props} fill="currentColor" />
export default SafetyLockIcon
